<template>
  <div>
    <div
      class="btn-wrapper d-flex justify-content-md-end justify-content-center"
    >
      <button
        class="btn btn-outline-primary wizard-btn prev-btn"
        @click="previous"
      >
        <i class="fa fa-arrow-left" aria-hidden="true"></i>
        {{ $t("global.return") }}
      </button>
      <button
        class="btn btn-primary wizard-btn next-btn"
        @click="nextStep"
        :disabled="false"
      >
        {{ $t("global.next") }}
        <i class="fa fa-arrow-right" aria-hidden="true"></i>
      </button>
    </div>
    <div class="row mb-4 mt-3">
      <div class="col-md-6 mb-3">
        <div class="card custom-card mb-5">
          <div class="card-body">
            <div class="py-2 px-3 custom-card">
              <div class="row">
                <div class="col-6 jjj">
                  <label
                    >Associer mon retour à une demande de régie existante</label
                  >
                </div>
                <div class="col-6 jjj">
                  <div class="d-inline-flex mr-5">
                    <div class="custom-control custom-radio mb-3 ml-3 mr-5">
                      <input
                        type="radio"
                        id="yes"
                        :value="true"
                        name="yes"
                        v-model="existentDemand"
                        class="custom-control-input"
                      />
                      <label class="custom-control-label" for="yes">Oui</label>
                    </div>
                    <div class="custom-control custom-radio mb-3 ml-3">
                      <input
                        type="radio"
                        id="no"
                        :value="false"
                        name="no"
                        v-model="existentDemand"
                        class="custom-control-input"
                      />
                      <label class="custom-control-label" for="no">Non</label>
                    </div>
                  </div>
                </div>
              </div>
              <div class="row" v-if="existentDemand">
                <div class="col-4 jjj"><label>Demande de régie</label></div>
                <div class="col-6 jjj">
                  <select
                    class="form-control"
                    v-model="selectedRegie"
                    @change="handleSelectRegie"
                  >
                    <option
                      v-for="(regie, index) in regieHistory"
                      :value="regie"
                      :key="index"
                    >
                      {{
                        `${formatDate(new Date(regie.creationDate))} - ${
                          regie.effectiveAmount
                        } € - ${regie.structureName}`
                      }}
                    </option>
                    <option v-if="regieHistory.length == 0" value="" selected>
                      Il n'y a pas de demandes
                    </option>
                  </select>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="card custom-card mb-5">
          <div class="card-body">
            <div class="py-2 px-3 custom-card">
              <h5>Informations de la demande</h5>
              <label>Project / Actions</label>
              <div class="row">
                <div class="col-12 jjj px-4">
                  <textarea
                    class="form-control mt-4"
                    v-model="description"
                    cols="30"
                    rows="7"
                    placeholder="Description"
                  ></textarea>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="card custom-card">
          <div class="card-body">
            <div class="py-2 px-3 custom-card">
              <h5>Joindre les pièces comptables</h5>
              <div class="row" v-for="doc in documentsPaths">
                <div class="col-12 px-1">
                  <retour-file-upload :document="doc" />
                </div>
              </div>
              <div class="row">
                <button
                  class="document-add-button newPiece col-12"
                  @click="addOtherDocument"
                >
                  <i class="fa fa-plus" aria-hidden="true"></i>
                  Ajouter une nouvelle pièce
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="col-md-6">
        <div class="card custom-card">
          <div class="card-body">
            <div class="py-2 px-3 custom-card">
              <div class="row">
                <h5 class="col-6">Régie demandée</h5>
                <h5 class="col-6">Montant total dépensé</h5>
              </div>
              <div class="row">
                <div class="col-12 col-lg-6 jjj px-4">
                  <label for="amount">Veuillez saisir un montant</label>
                  <d-input
                    type="text"
                    id="amount"
                    v-model="amount"
                    placeholder="€"
                    onwheel="return false;"
                  />
                </div>
                <div class="col-12 col-lg-6 jjj px-4">
                  <label for="amount">Veuillez saisir un montant</label>
                  <d-input
                    type="text"
                    id="amount"
                    v-model="actualAmount"
                    placeholder="€"
                    onwheel="return false;"
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="card custom-card mt-5">
          <div class="card-body">
            <div class="py-2 px-3 custom-card">
              <h5>Structure</h5>
              <fieldset class="mt-0 d-flex flex-wrap">
                <div
                  v-for="structure in allStructures"
                  class="col-6 div-no-padding"
                >
                  <d-form-radio
                    v-model="selectedStructure"
                    :value="{ name: structure.name, id: structure.reference }"
                    class="mb-3"
                    >{{ structure.name }}</d-form-radio
                  >
                </div>
              </fieldset>
            </div>
          </div>
        </div>
        <div class="card custom-card mt-5">
          <div class="card-body">
            <div class="py-2 px-3 custom-card">
              <div
                class="d-flex justify-content-between align-items-center mb-4"
              >
                <div>
                  <h5 style="margin: 0">Joindre la feuille de comptabilité</h5>
                </div>
                <div>
                  <a
                    href="https://www.loom.com/share/fa7e5e95a79948e5983d763ce0af593d"
                    target="_blank"
                    class="mr-5"
                    >Tutoriel</a
                  >
                </div>
                <div>
                  <a
                    href="https://docs.google.com/spreadsheets/d/1DDQjHZPhuw7pQUMHsobXAV616Z1XLPh9/copy"
                    target="_blank"
                    class="btn generate-upload-contract-button"
                    ><i class="fa fa-download mr-2" aria-hidden="true"></i
                    >Obtenir le modèle</a
                  >
                </div>
              </div>
              <!-- <file-upload :document="excelDoc" /> -->
              <d-input
                type="text"
                id="excelDoc"
                v-model="excelDoc"
                placeholder="URL du fichier Google Sheet"
              />
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { fr } from "vuejs-datepicker/dist/locale";
import $ from "jquery";
import RetourFileUpload from "../../shared/retourUploadFile.vue";
import FileUpload from "../../shared/uploadFile.vue";
import validator from "validator";
import {
  ref,
  uploadBytes,
  uploadBytesResumable,
  getDownloadURL,
  getBlob,
} from "firebase/storage";
import { storage } from "../../../firebase/app";

export default {
  name: "StepTwo",
  props: ["user"],
  components: { RetourFileUpload, FileUpload },
  data() {
    return {
      description: "",
      amount: null,
      actualAmount: null,
      allStructures: [],
      selectedStructure: {},
      existentDemand: false,
      regieHistory: [],
      selectedRegie: null,
      additionalDocCounter: 2,
      excelDoc: "",
      documentsPaths: [
        {
          name: `nom de document`,
          showDelete: true,
          showUploadComplete: false,
          index: 1,
        },
      ],
      fr,
    };
  },

  mounted() {
    if (localStorage.getItem("model")) {
      let model = JSON.parse(localStorage.getItem("model"));
      (this.description = model.description),
        (this.selectedStructure = model.selectedStructure),
        (this.amount = model.amount),
        (this.actualAmount = model.actualAmount),
        (this.documentsPaths = model.documentsPaths),
        (this.excelDoc = model.excelDoc),
        (this.selectedRegie = model.selectedRegie),
        (this.existentDemand = model.existentDemand);
    }
    this.$services.structure.findAll().then((response) => {
      this.allStructures = response.data;
    });

    this.$services.regieRequestService
      .findDemandsByUserInThreeMonths(
        this.$store.state.user.informations.reference
      )
      .then((res) => {
        this.regieHistory = res.data;
      });
  },

  methods: {
    previous() {
      this.$emit("input", null);
    },

    nextStep() {
      if (
        !validator.isEmpty(this.description) &&
        this.amount != null &&
        this.actualAmount != null &&
        this.selectedStructure.id
      ) {
        let model = {
          existentDemand: this.existentDemand,
          description: this.description,
          selectedStructure: this.selectedStructure,
          structureID: this.selectedStructure.id,
          structureName: this.selectedStructure.name,
          amount: this.amount,
          actualAmount: this.actualAmount,
          applicantFirstName: this.user.firstName,
          applicantLastName: this.user.lastName,
          creationDate: new Date(),
          applicantID: this.user.reference,
          documentsPaths: this.documentsPaths,
          excelDoc: this.excelDoc,
          selectedRegie: this.selectedRegie,
        };
        this.$emit("input", model);
        localStorage.setItem("model", JSON.stringify(model));
      } else {
        this.$miniToastr.error("veuillez remplir tous les fichiers requis");
      }
    },
    handleSelectRegie() {
      this.description = this.selectedRegie.description;
      this.amount = this.selectedRegie.effectiveAmount;
      this.selectedStructure = {
        name: this.selectedRegie.structureName,
        id: this.selectedRegie.structureID,
      };
    },
    downloafUpload(filePath) {
      getDownloadURL(ref(storage, filePath))
        .then((url) => {
          let path = filePath;
          const xhr = new XMLHttpRequest();
          xhr.responseType = "blob";
          xhr.open("GET", url);
          xhr.send();
          xhr.onload = function () {
            const blob = new Blob([xhr.response]);
            const a = document.createElement("a");
            a.href = URL.createObjectURL(blob);
            a.download = path;
            a.click();
          };
        })
        .catch((error) => {
          console.error(error);
        });
    },
    formatDate(date) {
      var day = date.getDate();
      var month = date.getMonth() + 1; // JavaScript months are 0-based, so +1 is added
      var year = date.getFullYear();

      // Ensure the day and month are two digits long
      if (day < 10) day = "0" + day;
      if (month < 10) month = "0" + month;

      return day + "." + month + "." + year;
    },
    addOtherDocument() {
      this.documentsPaths.push({
        name: `Autre document ${this.additionalDocCounter}`,
        showDelete: true,
        showUploadComplete: false,
        index: this.additionalDocCounter,
      });
      this.additionalDocCounter++;
    },
    handleDeletingOtherDocuments(doc) {
      const index = this.documentsPaths.indexOf(doc);
      if (index > -1) {
        this.documentsPaths.splice(index, 1);
        this.additionalDocCounter--;
      }
    },
  },
};
</script>

<style scoped>
.card {
  position: relative;
  background-color: transparent;
}

.wizard-btn-wrapper {
  position: absolute;
  top: -120px;
  right: 0;
}

.custom-card {
  background-color: #ffffff;
}

.custom-datepicker input {
  border: none !important;
  background-color: #b6bbdd !important;
  color: #007bff !important;
  border-radius: 15px !important;
  width: 50% !important;
  text-align: center !important;
  font-weight: 600 !important;
}

.document-container {
  background-color: #f6f8ff;
  border-radius: 15px;
}

.document-inside-container {
  background-color: #ffffff;
  margin: 10px 20px;
  color: #1f88ff;
  padding: 10px;
  border-radius: 10px;
  font-size: 10px;
}

.document-inside-button {
  background-color: #ffffff;
  margin: 10px 20px;
  padding: 10px;
  border-radius: 10px;
  color: #5a6169;
  font-weight: 500;
  display: flex;
  justify-content: center;
}

.document-inside-button:hover {
  cursor: pointer;
}

.document-add-button {
  border: 2px #4f78e2 dashed;
  border-radius: 15px;
  height: 100%;
  color: #4f78e2;
  padding: 10px;
}

.document-delete-button {
  position: absolute;
  top: 0;
  right: 0;
  color: #fc452d;
  background-color: #fddad5;
  border-radius: 5px;
  height: 25px;
  width: 25px;
}

.div-no-padding {
  padding: 0 !important;
}

.upload-file-text {
  margin-left: 7px;
  text-align: center;
  display: block;
}

.upload-file-icon {
  display: block;
}

.document-upload-progress-circle {
  text-align: center;
  color: #1f88ff;
}

.text-red {
  color: red;
  /* font-size: 16px; */
  font-weight: 900;
}

.emailExist {
  color: red;
  border: 1px solid red;
}

.emailExist:hover {
  border: 2px solid red;
}

.emailExistErrorText {
  color: red;
}

.emailExistErrorTextUnder {
  text-decoration: underline;
}

.emailExistErrorTextUnder:hover {
  cursor: pointer;
}

input[type="number"]::-webkit-inner-spin-button,
input[type="number"]::-webkit-outer-spin-button {
  -webkit-appearance: none;
  margin: 0;
}

input[type="number"] {
  -moz-appearance: textfield;
}

.newPiece {
  padding: 30px 15px;
}
.generate-upload-contract-button {
  background-color: white !important;
  border: 1px solid #4f78e2;
  color: #4f78e2;
}
</style>
